import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

type ManualCreditsInfoDialogProps = {
  open: boolean
  onClose: () => void
}

export default function ManualCreditsInfoDialog({
  open,
  onClose,
}: ManualCreditsInfoDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>About Manual Credits</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          When a course or assignment shows a credit source, it means the
          completion was not earned organically — it was granted through a
          manual intervention. There are two types:
        </Typography>
        <Box component="ul" sx={{ pl: 2, mb: 3 }}>
          <li>
            <Typography variant="body2">
              <strong>Manager Credit</strong> — a manager manually marked this
              as complete.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Threshold Credit</strong> — the user had already completed
              this course within the configured threshold window, so credit was
              applied automatically instead of requiring them to redo it.
            </Typography>
          </li>
        </Box>

        <Typography variant="subtitle2" gutterBottom>
          Course Credit vs. Assignment Credit
        </Typography>
        <Box component="ul" sx={{ pl: 2 }}>
          <li>
            <Typography variant="body2">
              <strong>Course credit</strong> means an individual course within
              this assignment was manually credited.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Assignment credit</strong> means all courses in the
              assignment were credited, so the full assignment is marked
              complete. A user may have course credits without assignment credit
              if they still have remaining courses to finish.
            </Typography>
          </li>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
